// ================================
// CUSTOMER - LANDING PAGE
// ================================
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function Landing() {
  const navigate = useNavigate();
  const { user, role } = useAuth();

  // If already logged in, redirect
  React.useEffect(() => {
    if (user && role === 'customer') navigate('/dashboard');
    if (user && role === 'admin')    navigate('/admin/dashboard');
    if (user && role === 'driver')   navigate('/driver/queue');
  }, [user, role, navigate]);

  return (
    <div className="app-shell" style={{ position: 'relative', overflow: 'hidden' }}>
      {/* Logo Section — no separate logo mark; the background artwork's
          own W (on the globe) carries that role. */}
      <div style={{
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'flex-end',
        padding: '40px 28px', textAlign: 'center'
      }}>

        <h1 style={{
          fontFamily: 'Bebas Neue, sans-serif',
          fontSize: 38, color: '#e8e8e8',
          letterSpacing: 4, marginBottom: 4,
          textShadow: '0 2px 12px #000a'
        }}>Weedo World</h1>

        <p style={{
          fontSize: 11, color: '#3a5a8a',
          letterSpacing: 3, textTransform: 'uppercase',
          marginBottom: 48
        }}>Private Delivery</p>

        <button className="btn-primary" style={{ marginBottom: 12 }}
          onClick={() => navigate('/login')}>
          Sign In
        </button>

        <button className="btn-secondary"
          onClick={() => navigate('/signup')}>
          Request Membership
        </button>

        {/* Discreet driver/admin links */}
        <div style={{ marginTop: 32, display: 'flex', gap: 20 }}>
          <span
            onClick={() => navigate('/driver')}
            style={{ fontSize: 11, color: '#1e3a6a', cursor: 'pointer' }}>
            Driver Portal
          </span>
          <span
            onClick={() => navigate('/admin')}
            style={{ fontSize: 11, color: '#1e3a6a', cursor: 'pointer' }}>
            Admin
          </span>
        </div>
      </div>
    </div>
  );
}
